angular.module('mercury.modules.stock.stockorder')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.StockorderEdit', {
    url: '/stockorder/edit?creditRequest&templateId&importFromLocalStorage',
    templateUrl: 'modules/stock/stockorder/edit.tpl.html',
    controller: 'StockStockorderEditCtrl',
    data: {
      menuLinkState: 'Stock.PurchaseorderActive'
    }
  });
}]);
